import React, { Component } from "react";
import { Col, Row, Button, Popover, Form, InputNumber } from "antd";
import { DownloadOutlined, } from "@ant-design/icons";
import ExportJsonExcel from "js-export-excel";
import { nanoid } from "nanoid";

import { formatYMD, formatDateTime } from '@/utils/date';
import { dict } from '@/nano';

export default class ExportExcel extends Component {
  formRef = React.createRef();
  state = {
    options: {},
    loading: false,
  };

  dictItemData = [];

  onConfirm = () => {
    this.setState({
      ...this.state,
      loading: true,
    }, () => {
      this.formRef.current.submit();
      this.props.onConfirm && this.props.onConfirm();
      this.setState({
        ...this.state,
        loading: false,
      });
    });
  };

  onExportData = (value) => {
    const { queryMethod, queryParam } = this.props;
    const { pageSize = 10 } = queryParam;
    const data = {
      ...queryParam,
      pageNum: value.pageBeginNum,
      pageSize: value.pageEndNum * pageSize,
    };
    queryMethod(data).then(res => {
      const sourceData = res.data;
      const { options, values } = this.props; // 页面展示列
      if (options && sourceData) {
        // 批量查询数据字典
        var dictArr = [];
        for (var i = 0; i < options.length; i++) {
          if (options[i].dict && values.includes(options[i].value)) {
            dictArr.push({ dictCode: options[i].dict });
          };
        };

        if (dictArr) {
          var dictPromise = dictArr.map(function (item) {
            return dict.getDictItemList(item);
          });

          Promise.all(dictPromise).then(res => {
            this.dictItemData = res;
            // 组装数据
            let fieldData = this.onDealFieldInfo(options, sourceData.list);
            // 导出文件
            this.handleExportCurrentExcel(fieldData, options);
          });
        } else {
          // 组装数据
          let fieldData = this.onDealFieldInfo(options, sourceData.list);
          // 导出文件
          this.handleExportCurrentExcel(fieldData, options);
        }
      };
    });
  };

  /**
    *  组装数据
    */
  onDealFieldInfo = (fieldArr, dataArr) => {
    var result = [];
    const exportFields = this.props.values; // 需要导出的字段
    for (var i = 0; i < dataArr.length; i++) {
      var fieldList = {};
      for (var j = 0; j < fieldArr.length; j++) {
        var fieldName = fieldArr[j].value; // 字段名
        if (fieldName !== "action" && exportFields.includes(fieldName)) {
          var fieldValue = dataArr[i][fieldName];
          var newFieldValue = fieldValue;
          // 处理数据
          if (this.dictItemData && fieldValue) {
            for (var k = 0; k < this.dictItemData.length; k++) {
              var itemData = this.dictItemData[k];
              for (var m = 0; m < itemData.length; m++) {
                var dictItem = itemData[m];
                if (dictItem.dictCode === fieldArr[j].dict && dictItem.value === fieldValue.toString()) {
                  newFieldValue = dictItem.label;
                }
              }
            }
          };

          var fieldType = fieldArr[j].fieldType; // 字段类型
          // 日期处理
          if (fieldType === "datetime") {
            newFieldValue = formatDateTime(fieldValue);
          } else if (fieldType === "date") {
            newFieldValue = formatYMD(fieldValue);
          }

          const format = fieldArr[j].format;
          if (format) {
            newFieldValue = format(fieldValue, dataArr[i], i);
          }

          fieldList[fieldName] = newFieldValue;
        };
      };
      if (fieldList) {
        result.push(fieldList);
      };
    };

    return result;
  };

  /**
    *  导出数据
    */
  handleExportCurrentExcel = (data, fieldArr) => {
    let sheetFilter = [];
    let sheetHeader = [];
    const columnStyles = []; // 设置列宽度
    const exportFields = this.props.values; // 需要导出的字段
    for (var i = 0; i < fieldArr.length; i++) {
      if (fieldArr[i].value !== "action" && exportFields.includes(fieldArr[i].value)) {
        sheetFilter.push(fieldArr[i].value);
        sheetHeader.push(fieldArr[i].label);
        if (fieldArr[i].exportWidth) {
          columnStyles.push(fieldArr[i].exportWidth);
        } else {
          columnStyles.push(8); // 不设宽度的全部设置为8
        }
      };
    };

    sheetFilter.join(", ");
    sheetHeader.join(", ");

    let option = {};
    let id = nanoid(32);
    option.fileName = id;
    option.datas = [
      {
        sheetData: data,
        //sheetName: "导出",
        sheetFilter: sheetFilter,
        sheetHeader: sheetHeader,
        columnWidths: columnStyles,
        columnStyles: columnStyles // 根据列宽度设置列样式
      },
    ];
    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel()
  };

  render() {
    const { loading } = this.state;
    return (
      <Popover
        trigger="click"
        placement="bottomRight"
        title="导出Excel"
        content={(
          <Form
            ref={this.formRef}
            onFinish={this.onExportData}
          >
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="pageBeginNum"
                  label="开始页码"
                  rules={[
                    {
                      required: true, message: "请输入开始页码"
                    }
                  ]}
                >
                  <InputNumber />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="pageEndNum"
                  label="结束页码"
                  rules={[
                    {
                      required: true, message: "请输入结束页码"
                    }
                  ]}
                >
                  <InputNumber />
                </Form.Item>
              </Col>
            </Row>
            <div style={{ textAlign: 'center' }}>
              <Button
                type="primary"
                size="small"
                loading={loading}
                onClick={this.onConfirm}
              >
                {"导出"}
              </Button>
            </div>
          </Form>
        )}
      >
        <Button
          type="primary"
          loading={loading}
          icon={<DownloadOutlined />}
        >
          {"导出"}
        </Button>
      </Popover>
    );
  };
};
